"use strict";

exports.__esModule = true;
exports.Vesting = void 0;
var _sdkCore = require("@acala-network/sdk-core");
var _storage = require("@acala-network/sdk/utils/storage");
var _rxjs = require("rxjs");
class Vesting {
  constructor(_ref) {
    let {
      api,
      tokenProvider
    } = _ref;
    this.api = void 0;
    this.tokenProvider = void 0;
    this.api = api;
    this.tokenProvider = tokenProvider;
  }
  subscribeVestingDetail(address) {
    const schedules$ = _storage.Storage.create({
      api: this.api,
      path: 'query.vesting.vestingSchedules',
      params: [address]
    }).observable;
    const locks$ = _storage.Storage.create({
      api: this.api,
      path: 'query.balances.locks',
      params: [address]
    }).observable;
    // get parachain block  api.query.parachainSystem.validationData()
    const parachain$ = _storage.Storage.create({
      api: this.api,
      path: 'query.parachainSystem.validationData',
      params: []
    }).observable;
    const token = this.tokenProvider.getNativeToken();
    return (0, _rxjs.combineLatest)({
      schedules: schedules$,
      locks: locks$,
      parachain: parachain$
    }).pipe((0, _rxjs.map)(_ref2 => {
      let {
        schedules,
        locks,
        parachain
      } = _ref2;
      const locking = locks === null || locks === void 0 ? void 0 : locks.find(i => i.id.eq('ormlvest'));
      const currentLock = _sdkCore.FixedPointNumber.fromInner((locking === null || locking === void 0 ? void 0 : locking.amount.toString()) || 0, token.decimals);
      const list = schedules.map(schedule => {
        const parachainBlock = parachain.isSome ? parachain.value.relayParentNumber.toBigInt() : BigInt(0);
        const startBlock = (schedule === null || schedule === void 0 ? void 0 : schedule.start.toBigInt()) || BigInt(0);
        const period = (schedule === null || schedule === void 0 ? void 0 : schedule.period.toBigInt()) || BigInt(0);
        const prePeriod = _sdkCore.FixedPointNumber.fromInner((schedule === null || schedule === void 0 ? void 0 : schedule.perPeriod.toString()) || 0, token.decimals);
        const periodCount = (schedule === null || schedule === void 0 ? void 0 : schedule.periodCount.toBigInt()) || BigInt(0);
        const total = prePeriod.mul(new _sdkCore.FixedPointNumber(periodCount.toString()));
        const endBlock = startBlock + period * periodCount;
        const planToClaim = startBlock + period < parachainBlock && period !== BigInt(0) ? prePeriod.mul(new _sdkCore.FixedPointNumber(((parachainBlock - startBlock) / period).toString()).min(new _sdkCore.FixedPointNumber(periodCount.toString()))) : _sdkCore.FixedPointNumber.ZERO;
        return {
          token,
          total,
          planToClaim,
          prePeriod,
          parachainBlock,
          startBlock,
          endBlock,
          period,
          periodCount
        };
      });
      const total = list.reduce((i, j) => i.add(j.total), _sdkCore.FixedPointNumber.ZERO);
      const planToClaim = list.reduce((i, j) => i.add(j.planToClaim), _sdkCore.FixedPointNumber.ZERO);
      const remaining = currentLock;
      const claimed = total.minus(remaining).max(_sdkCore.FixedPointNumber.ZERO);
      const available = planToClaim.minus(claimed).max(_sdkCore.FixedPointNumber.ZERO);
      return {
        token,
        total,
        claimed,
        remaining,
        available,
        details: list
      };
    }));
  }
  async getVestingDetail(address) {
    return (0, _rxjs.firstValueFrom)(this.subscribeVestingDetail(address));
  }
}
exports.Vesting = Vesting;